/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlockExpenseApprovalRequest
 */
export interface BlockExpenseApprovalRequest {
    /**
     * 
     * @type {string}
     * @memberof BlockExpenseApprovalRequest
     */
    message: string;
}

/**
 * Check if a given object implements the BlockExpenseApprovalRequest interface.
 */
export function instanceOfBlockExpenseApprovalRequest(value: object): value is BlockExpenseApprovalRequest {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function BlockExpenseApprovalRequestFromJSON(json: any): BlockExpenseApprovalRequest {
    return BlockExpenseApprovalRequestFromJSONTyped(json, false);
}

export function BlockExpenseApprovalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockExpenseApprovalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function BlockExpenseApprovalRequestToJSON(value?: BlockExpenseApprovalRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
    };
}

